import React, { useEffect, useState } from 'react';
import {
  MemoryRouter,
  Redirect,
  Route
} from 'react-router-dom';

import BaseLayout from './components/BaseLayout';
import StartPage from './components/StartPage';
import ShareLoader from './components/ShareLoader';
import Markup from './markup';
import { trackHomePage } from './utils/Analytics';


// Fonts
require('typeface-noto-sans');
require('typeface-fjalla-one');
require('typeface-maven-pro');
require('typeface-nunito-sans');

trackHomePage();

// Capture cart-edit URL params at module load time — before any React render
// or useEffect can strip them (App.tsx pushState strips query params on mount).
// sessionStorage persists for the tab lifetime and is cleared automatically.
(function captureCartEditParams() {
  const params = new URLSearchParams(window.location.search);
  const action = params.get('builder_action');
  if (action) {
    sessionStorage.setItem('builder_action', action);
    sessionStorage.setItem('builder_project_id', params.get('project_id') || '');
    sessionStorage.setItem('builder_cart_data', params.get('cart_data') || '');
  } else {
    // Clear stale edit params when starting a fresh build (no builder_action in URL)
    sessionStorage.removeItem('builder_action');
    sessionStorage.removeItem('builder_project_id');
    sessionStorage.removeItem('builder_cart_data');
  }
})();

function App() {
  const [manifest, setManifest] = useState(null);
  const [shareData, setShareData] = useState(null);
  const [errorState, setErrorState] = useState(false);

  const shareParam = (new URLSearchParams(window.location.search)).get('share');
  
  //Prevent Navigation
  useEffect(() => {
    const handlePopState = (event) => {
        window.history.go(1);
    };

    window.history.pushState(null, document.title, window.location.pathname);
    window.addEventListener('popstate', handlePopState);

    return () => {
        window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return (
    <>
      <MemoryRouter>
        {manifest && <Redirect to='/design' />}
        {shareParam && <Redirect to='/share' />}
        {errorState && <Markup.Global.Notification.ErrorNotification>An error occured, please try using the share link later</Markup.Global.Notification.ErrorNotification>}
        <Route path='/' exact>
          <StartPage setManifest={setManifest} />
        </Route>
        <Route path='/share/'>
          <ShareLoader setManifest={setManifest} setShareData={setShareData} shareData={shareParam} setErrorState={setErrorState} />
        </Route>
        <Route path={['/name', '/logos', '/design', '/color', '/info', '/flag', '/submit']}>
          <BaseLayout setManifest={setManifest} manifest={manifest} shareData={shareData} setShareData={setShareData} />
        </Route>
      </MemoryRouter>
    </>
  );
}

export default App;
